import React, { useState } from "react";
import {
  Plus,
  Folder,
  FolderPlus,
  Users,
  Search,
  ChevronDown,
  FileText,
  Database,
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
const Templates = () => {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen bg-gradient-to-br from-[#0d1b2a] to-[#1a2d45] text-white">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0d1b2a]/80 backdrop-blur-lg border-r border-[#2d3e56] flex flex-col">
        {/* Logo */}
        <div className="flex items-center px-6 py-6 border-b border-[#2d3e56]">
          <img
            src="/assets/images/rlogo.png"
            alt="Redian Logo"
            className="h-12 w-100 object-contain mr-3"
          />
          {/* <span className="font-bold text-xl tracking-tight">Redian</span> */}
        </div>

        {/* Nav */}
        <nav className="flex-1 px-4 py-6 space-y-1">
          {/* Create Project */}
          <Link
            to="/create"
            className="w-full flex items-center justify-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 py-3 rounded-lg mb-6 transition-all duration-200 shadow-lg shadow-blue-600/20"
          >
            <Plus size={18} />
            <span className="font-medium">Create Project</span>
          </Link>

          {/* Projects */}
          <Link
            to="/home"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg hover:bg-[#2d3e56] cursor-pointer group transition-colors"
          >
            <Folder
              size={18}
              className="text-gray-400 group-hover:text-white"
            />
            <span className="text-gray-300 group-hover:text-white">
              Projects
            </span>
          </Link>

          {/* Templates (active) */}
          <Link
            to="/templates"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg bg-blue-600/20 border border-blue-500/30 cursor-pointer group transition-colors"
          >
            <FolderPlus size={18} className="text-blue-400" />
            <span className="font-medium">Templates</span>
          </Link>

          {/* Assemblies */}
          <Link
            to="/assemblies"
            className="flex items-center space-x-3 px-3 py-3 rounded-lg hover:bg-[#2d3e56] cursor-pointer group transition-colors"
          >
            <Database
              size={18}
              className="text-gray-400 group-hover:text-white"
            />
            <span className="text-gray-300 group-hover:text-white">
              Assemblies
            </span>
          </Link>
        </nav>

        {/* Footer */}
        <div className="px-4 py-4 border-t border-[#2d3e56]">
          <div className="text-sm text-gray-400 font-medium mb-2">
            Demo Projects
          </div>
          <div className="space-y-2">
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Architecture Concept
            </div>
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Urban Planning
            </div>
            <div className="text-xs text-gray-500 hover:text-gray-300 cursor-pointer py-1 transition-colors">
              Landscape Design
            </div>
          </div>
          {/* Logout Button */}
          <div className="mt-6">
            <Link
              to="/"
              className="w-full flex items-center justify-center px-4 py-2 text-sm font-medium text-red-400 border border-red-500/40 rounded-lg hover:bg-red-500/10 hover:text-red-300 transition-colors"
            >
              Logout
            </Link>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 flex flex-col overflow-hidden">
        {/* Topbar */}
        <header className="flex items-center justify-between px-8 py-4 border-b border-[#2d3e56] bg-[#0d1b2a]/50 backdrop-blur-sm">
          <div className="flex-1 h-16 max-w-2xl relative">
            <Search
              size={18}
              className="absolute left-3 top-6 transform -translate-y-1/2 text-gray-400"
            />
            <input
              type="text"
              placeholder="Search templates by name or category..."
              className="w-full pl-10 pr-4 py-3 bg-[#1b263b] border border-[#2d3e56] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all"
            />
          </div>
          <div className="flex items-center space-x-4 ml-6">
            {/* <button className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-2 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-600/20">
              <Users size={16} />
              <span className="font-medium">Invite Team</span>
            </button> */}
            <div className="flex items-center space-x-3">
              <div className="h-9 w-16 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center font-semibold shadow-lg">
                Admin
              </div>
              {/* <ChevronDown
                size={16}
                className="text-gray-400 cursor-pointer hover:text-white transition-colors"
              /> */}
            </div>
          </div>
        </header>

        {/* Content */}
        <div className="flex-1 p-8 overflow-auto">
          {/* Header Section */}
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl font-bold mb-2 flex items-center space-x-3">
                <div className="p-2 bg-blue-500/10 rounded-xl">
                  <FolderPlus size={24} className="text-blue-400" />
                </div>
                <span>Project Templates</span>
              </h2>
              <p className="text-gray-400">
                Create and manage templates to streamline your project workflow
              </p>
            </div>

            <div className="flex items-center space-x-3">
              <select className="bg-[#1b263b] border border-[#2d3e56] text-sm rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all">
                <option>All Categories</option>
                <option>Architecture</option>
                <option>Urban Planning</option>
                <option>Landscape Design</option>
              </select>
              <select className="bg-[#1b263b] border border-[#2d3e56] text-sm rounded-xl px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all">
                <option>Sort by: Newest</option>
                <option>Sort by: Most Used</option>
                <option>Sort by: Alphabetical</option>
              </select>
            </div>
          </div>

          {/* Empty State */}
          <div className="flex flex-col items-center justify-center h-full text-center">
            <div className="max-w-md mx-auto">
              <div className="inline-flex p-6 bg-blue-500/10 rounded-2xl mb-6">
                <FileText size={48} className="text-blue-400" />
              </div>
              <h3 className="text-2xl font-bold mb-2">No templates found</h3>
              <p className="text-gray-400 mb-8">
                Start by creating your first template or explore existing
                categories
              </p>

              <div className="grid grid-cols-2 gap-4 max-w-md">
                <button className="flex flex-col items-center p-6 rounded-2xl bg-[#1b263b] border border-[#2d3e56] hover:border-blue-500/50 hover:bg-[#2d3e56] transition-all duration-200 group">
                  <div className="p-3 bg-blue-500/10 rounded-xl mb-3 group-hover:bg-blue-500/20 transition-colors">
                    <Plus size={24} className="text-blue-400" />
                  </div>
                  <span className="font-medium mb-1">Create Template</span>
                  <span className="text-xs text-gray-400">
                    Start from scratch
                  </span>
                </button>

                <button className="flex flex-col items-center p-6 rounded-2xl bg-[#1b263b] border border-[#2d3e56] hover:border-blue-500/50 hover:bg-[#2d3e56] transition-all duration-200 group">
                  <div className="p-3 bg-purple-500/10 rounded-xl mb-3 group-hover:bg-purple-500/20 transition-colors">
                    <Users size={24} className="text-purple-400" />
                  </div>
                  <span className="font-medium mb-1">Team Templates</span>
                  <span className="text-xs text-gray-400">
                    Collaborate with team
                  </span>
                </button>
              </div>

              {/* Template Categories Preview */}
              <div className="mt-8 pt-8 border-t border-[#2d3e56]">
                <p className="text-sm text-gray-400 mb-4">
                  Popular template categories
                </p>
                <div className="grid grid-cols-2 gap-3">
                  <button className="px-4 py-3 text-sm bg-[#1b263b] border border-[#2d3e56] rounded-xl hover:border-blue-500/50 transition-colors text-left">
                    <div className="font-medium mb-1">Architecture</div>
                    <div className="text-xs text-gray-400">
                      Building designs & plans
                    </div>
                  </button>
                  <button className="px-4 py-3 text-sm bg-[#1b263b] border border-[#2d3e56] rounded-xl hover:border-green-500/50 transition-colors text-left">
                    <div className="font-medium mb-1">Urban Planning</div>
                    <div className="text-xs text-gray-400">
                      City layouts & zoning
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Templates;
